import { Loading, Modal, Toast } from 'components/Modal';
import { apiClient, assets, os, useAuthorize, useTitle } from 'modules';
import { history } from 'modules/navigator';
import { setup as mpSetup, useShare as wxShare } from 'modules/weixin';
import qs from 'query-string';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { WITHDRAW_MIN_AMOUNT } from './config';
import styles from './index.module.scss';

export default function InviteGift() {
  useTitle('邀请赚红包');
  const [user] = useAuthorize();

  const [role, setRole] = useState(false);
  const [message, setMessage] = useState('');
  const [toastVisible, setToastVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState('');
  const [loadingVisible, setLoadingVisible] = useState(false);
  const [userinfo, setUserinfo] = useState({ nickname: '' });
  const [inviteAward, setInviteAward] = useState({ count: 0, money: 0 });

  function showOauthToast() {
    const token = qs.parse(window.location.search).token;

    if (typeof token === 'string') {
      showToast('去生成专属邀请图吧');
      history.replace(window.location.pathname);
    }
  }

  function showModal(type: string) {
    setModalVisible(type);
  }

  function showTipModal() {
    showModal('tip');
  }

  function showSelectRoleModal() {
    showModal('selectRole');
  }

  function hideModal() {
    showModal('');
  }

  function showLoading() {
    setLoadingVisible(true);
  }

  function hideLoading() {
    setLoadingVisible(false);
  }

  function showToast(newMessage: string) {
    setMessage(newMessage);
    setToastVisible(true);

    setTimeout(() => {
      setToastVisible(false);
    }, 2000);
  }

  async function selectRole(type: number) {
    const response = await apiClient.invite.poster({
      type
    });

    // 未关注公众号
    if (response.status === 21201 || response.status === 21202) {
      setRole(true);
      hideModal();

      apiClient.base.oauth();

      return;
    }

    if (response.status !== 10000) {
      showToast(response.msg);

      return;
    }

    setRole(true);
    hideModal();
  }

  async function fetchPoster() {
    showLoading();
    const response = await apiClient.invite.poster();

    const selectedRole = response.status === 10000;

    setRole(selectedRole);
    hideLoading();

    if (!selectedRole) {
      showSelectRoleModal();
    } else {
      showOauthToast();
    }
  }

  async function fetchUserinfo() {
    const response = await apiClient.base.userinfo();
    if (response.status !== 10000) {
      showToast(response.msg);

      return;
    }

    fetchPoster();
    setUserinfo(response.body);
  }

  async function fetchInviteAward() {
    const response = await apiClient.invite.award();

    if (response.status !== 10000) {
      if (response.status === 80003) {
        user.logout();
        user.login();
      }

      return;
    }

    setInviteAward(response.body);
  }

  async function fetchAccount() {
    fetchInviteAward();
    fetchUserinfo();
  }

  useEffect(() => {
    if (!os.isWp) {
      alert('请在微信中访问本网址，继续参加活动');

      return;
    }

    user.init();

    mpSetup(window.location.href);
    wxShare({
      desc: '【已经有357人领取红包，手慢无】',
      imgUrl: 'https://assets.gongji58.com/invitation_share.jpg',
      link: window.location.href,
      title: '18元+的红包等你领，看看手气'
    });

    if (user.authorized) {
      fetchAccount();
    }
  }, []);

  async function handleSelectWjRole() {
    selectRole(1);
  }

  async function handleSelectCcRole() {
    selectRole(2);
  }

  function gotoWithdraw() {
    if (Number(inviteAward.money) < WITHDRAW_MIN_AMOUNT) {
      showTipModal();
    } else {
      history.push('/withdraw');
    }
  }

  function gotoShareImage() {
    if (!user.authorized) {
      return;
    }
    if (!role) {
      showSelectRoleModal();

      return;
    }

    history.push('/invitation_gift/share_image');
  }

  return (
    <div className={styles.container}>
      <Loading isOpen={loadingVisible} />
      <Toast isOpen={toastVisible} message={message} />
      <Modal isOpen={modalVisible === 'tip'}>
        <div className={styles.modalHeader}>温馨提示</div>
        <div className={styles.modalTipBody}>
          <div className={styles.modalTipText}>
            单次提现金额不能低于{WITHDRAW_MIN_AMOUNT}元
          </div>
          <div className={styles.modalTipHint}>
            (请超过{WITHDRAW_MIN_AMOUNT}元后再来)
          </div>
        </div>
        <div className={styles.bottomCloseIcon} onClick={hideModal} />
      </Modal>
      <Modal isOpen={modalVisible === 'selectRole'}>
        <div className={styles.topCloseIcon} onClick={hideModal} />
        <div className={styles.modalHeader}>选择身份</div>
        <div className={styles.selectRoleBody}>
          <div className={styles.roleItem} onClick={handleSelectWjRole}>
            <img
              className={styles.roleItemImage}
              src={assets.invitationGift.wj}
            />
            <div className={styles.roleItemTitle}>我是搞挖机的</div>
          </div>
          <div className={styles.roleItemDivider} />
          <div className={styles.roleItem} onClick={handleSelectCcRole}>
            <img
              className={styles.roleItemImage}
              src={assets.invitationGift.cc}
            />
            <div className={styles.roleItemTitle}>我是搞铲车的</div>
          </div>
        </div>
      </Modal>
      <img className={styles.gift} src={assets.invitationGift.card} />
      <div className={styles.steps}>
        <div className={styles.step}>
          <div className={styles.stepNo}>1</div>
          <div className={styles.stepText}>
            <span className={styles.stepTextP}>下载邀请图</span>
          </div>
        </div>
        <img
          className={styles.pointRightIcon}
          src={assets.invitationGift.pointerRight}
        />
        <div className={styles.step}>
          <div className={styles.stepNo}>2</div>
          <div className={styles.stepText}>
            <span className={styles.stepTextP}>转发邀请图</span>
            <span className={styles.stepTextP}>到群或者朋友圈</span>
          </div>
        </div>
        <img
          className={styles.pointRightIcon}
          src={assets.invitationGift.pointerRight}
        />
        <div className={styles.step}>
          <div className={styles.stepNo}>3</div>
          <div className={styles.stepText}>
            <span className={styles.stepTextP}>他人关注后</span>
            <span className={styles.stepTextP}>获得红包</span>
          </div>
        </div>
      </div>
      <img className={styles.pointer} src={assets.invitationGift.pointer} />
      <div onClick={gotoShareImage} className={styles.button}>
        <img
          src={assets.invitationGift.download}
          className={styles.downloadIcon}
        />
        点此生成你的专属邀请图
      </div>
      <div className={styles.divider} />
      <div className={styles.panel}>
        <div className={styles.panelTitle}>{user.authorized && '我的红包'}</div>
        {user.authorized && (
          <>
            <div className={styles.inviteDetail}>
              您的账号：{userinfo.nickname}
              <Link to="/invitation_gift/list">
                <div className={styles.inviteDetailTag}>查看邀请明细</div>
              </Link>
            </div>
            <div className={styles.inviteTip}>
              您已成功邀请
              <span className={styles.inviteTipValue}>{inviteAward.count}</span>
              人，成功获得
              <span className={styles.inviteTipValue}>{inviteAward.money}</span>
              元红包
            </div>
            <div className={styles.withdrawButton} onClick={gotoWithdraw}>
              <img
                className={styles.coinIcon}
                src={assets.invitationGift.coin}
              />
              申请提现
            </div>
          </>
        )}
      </div>
      <div className={styles.panel}>
        <div className={styles.panelTitle}>提现规则</div>
        <div className={styles.rules}>
          <div className={styles.rule}>1、金额满18元才可申请提现</div>
          <div className={styles.rule}>
            2、提交提现申请后，现金红包会发放至您的微信
          </div>
        </div>
      </div>
      <div className={styles.panel}>
        <div className={styles.panelTitle}>活动规则</div>
        <div className={styles.rules}>
          <div className={styles.rule}>
            1、由于本行业以男性用户为主，故谢绝邀请女性用户；
          </div>
          <div className={styles.rule}>
            2、邀请的人关注公众号后，24小时内取消关注不算数；
          </div>
          <div className={styles.rule}>
            3、如有违规刷单操作，平台会对违规账号进行封号处理，并取消红包奖励；
          </div>
        </div>
      </div>
    </div>
  );
}
